import { memo as u, useMemo as d } from "react";
import { mergeMeshes as M } from "../../geometry-utils/three/index17.js";
import { RgInstances as l } from "./index6.js";
import { jsx as m, Fragment as v } from "react/jsx-runtime";
const L = u(({
  buildingChildren: a,
  layer: o,
  visibility: n,
  views: i,
  layerID: f,
  colourFunc: c,
  ...h
}) => {
  const g = d(() => {
    const e = /* @__PURE__ */ new Map();
    for (const s of i.values())
      s.updateColour(c);
    for (const s of a) {
      if (o.cancel && o.cancel(s))
        continue;
      const t = i.get(s.hash);
      let r = e.get(s.hash);
      if (!r) {
        if (t.position.setScalar(0), t.rotation.fromArray([0, 0, 0]), t.setVisibility({
          visibility: n,
          visible: o.visible
        }), !t.activeMeshes)
          continue;
        const p = M(t);
        r = {
          layerID: f,
          view: t,
          geo: p,
          layer: o,
          instances: [],
          activeMeshes: t.activeMeshes
        }, e.set(s.hash, r);
      }
      r.instances.push(s);
    }
    return e;
  }, [a, o, n, i, c]);
  return /* @__PURE__ */ m(v, {
    children: Array.from(g).filter(([, e]) => e.instances.length).map(([, e]) => /* @__PURE__ */ m(l, {
      mergedList: e,
      visibility: n,
      renderOrder: o.renderOrder,
      ...h
    }, e.geo.uuid))
  });
});
L.displayName = "BuildingLayer";
export {
  L as BuildingFcLayer
};
//# sourceMappingURL=index3.js.map
